import { useEffect } from "react";
import { BreadcrumbProps } from "@Types/Breadcrumbs";
import {
  setHomeSlug,
  setCollectionSlug,
  setCurrentSlug,
} from "@wff/store/breadcrumbsSlice";
import { useAppDispatch } from "@wff/store/hooks";

export const useBreadcrumb = (props: BreadcrumbProps) => {
  // homeSlug: {title: "title", link:"/"} - (Set automatically in Contentful pages) - The First part of the slug, usually the Root.
  // collectionSlug: {title: "title", link:"/"} - (Needs to be set where the link is before user redirect) - The slug for the navigation category or product category (The collection where the link the user comes from is).
  // currentSlug: {title: "title", link:"/"} - (Needs to be set in the actual page) - The slug for the actual page where user is (The page the user is right now).

  const { homeSlug, collectionSlug, currentSlug } = props;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (homeSlug) dispatch(setHomeSlug(homeSlug));
    if (collectionSlug) dispatch(setCollectionSlug(collectionSlug));
    if (currentSlug) dispatch(setCurrentSlug(currentSlug));
  }, [homeSlug, collectionSlug, currentSlug, dispatch]);
};
